export const COURSE_SECTIONS = 'COURSE_SECTIONS';
export const courseSections = q => ({
  type: COURSE_SECTIONS,
  payload: q
});
